/**
 * The header links that carry what is open to another analyzer (`Actions/Analyzers.jsx`).
 * With a repricing pass only DOR and LOR apply; the others are not shown at all (decision 4, CU-869fmm944).
 */
export const ANALYZER_KEYS = ['lor', 'dor', 'direct-site', 'brokers', 'rating', 'position', 'one-way']

/** Which links the header shows, in its order. `path` is the current pathname. */
export function analyzerLinks({ path = '', pass = null, hasDirectSites = false, hasCompetitionSites = false, oneWay = false }) {
	const here = key => path.includes(key)
	if (pass) return ['lor', 'dor'].filter(key => !here(key))
	return ANALYZER_KEYS.filter(key => {
		if (here(key)) return false
		if (key === 'direct-site') return !!hasDirectSites
		if (key === 'brokers' || key === 'rating') return !!hasCompetitionSites
		if (key === 'one-way') return !!oneWay
		return true
	})
}

/** The query that opens the same thing in another analyzer. */
export function analyzerUrlId({ searchID, pass, report }) {
	if (searchID) return `idSearch=${searchID}`
	if (pass) return `idRepricingExecution=${encodeURIComponent(pass)}`
	return `idReportExecution=${report}`
}
